import { render, staticRenderFns } from "./ViewerContent.vue?vue&type=template&id=c850bdca&"
import script from "./ViewerContent.vue?vue&type=script&lang=js&"
export * from "./ViewerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports